module.exports = __webpack_public_path__ + "img/outlineBorder1.b16b7924.png";